import router from "@/router";

export function publixLoginGuid(data={}){
  const {systemInfo,loginUrl} = data
  if(['2'].includes(systemInfo?.loginType)){//统一认证会有重定向，我这边不需要存回到哪里
    // console.log('publixLoginGuid')
    // console.log(`${systemInfo?.casloginUrl}?url=${encodeURIComponent(window.location.href)}`)
    // console.log('------------------------')
    window.location.href=`${systemInfo?.casloginUrl}?url=${encodeURIComponent(window.location.href)}`;
    return
  }
  if(loginUrl){//论文提交存特殊的缓存用于区分
    setLocationItem('loginUrl',loginUrl)//存入要跳转的地址，登录后直接跳转
  }else{
    setLocationItem('loginUrl',window.location.href)//存入要跳转的地址，登录后直接跳转
  }
  router.push('/login')
  return;
}

export function getLocationItem(key){
  const keyContent = window.localStorage.getItem(key)
  return keyContent
}

export function removeLocationItem(key){
  window.localStorage.removeItem(key)
}

export function setLocationItem(key,value){
  window.localStorage.setItem(key,value)
}
// localStorage.setItem('loginUrl', window.location.href);

export function isMobileDevice(){//判断是否是移动设备（可能不支持window.open）
  // // 获取用户代理信息(不考虑代理信息被伪装的情况)
  // const userAgent = (navigator.userAgent || navigator.vendor || window.opera) || 'Unknown';
  // // 检查是否是iPhone或iPad
  // const userAgentFlag= /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  const userAgent = window.navigator.userAgent.toLowerCase();
  console.log('userAgent')
  console.log(userAgent)
// 判断是否为移动设备
  const isMobile = /iphone|ipad|android|mobile|phone/.test(userAgent);
  console.log(isMobile)
  console.log('--------------')
  return isMobile;
}
